import Vue from 'vue';

export default {
    install: (App) => {
        App.mixin({
            beforeCreate() {
                // eslint-disable-next-line better-mutation/no-mutating-functions
                if (typeof this.$options.static === 'function') {
                    this.$options.static = this.$options.static.call(this);
                }
                Object.assign(this, this.$options.static);
            }
        });
    }
};

Vue.config.optionMergeStrategies.static = (fromOption = {}, toOption = {}) =>
    function() {
        return {
            ...(typeof fromOption === 'function' ? fromOption.call(this) : fromOption),
            ...(typeof toOption === 'function' ? toOption.call(this) : toOption)
        };
    };
